import { render, staticRenderFns } from "./areaPopup.vue?vue&type=template&id=0d2b0aa9&scoped=true"
import script from "./areaPopup.vue?vue&type=script&lang=js"
export * from "./areaPopup.vue?vue&type=script&lang=js"
import style0 from "./areaPopup.vue?vue&type=style&index=0&id=0d2b0aa9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2b0aa9",
  null
  
)

export default component.exports